import { WbIcon, WbPopover, WbText } from '@workbench/react';
import InfoPanelsTable from './InfoPanelsTable';
import './PanelHeader.scss';

function PanelHeader({ headerName, data, description, title }) {
	return (
		<div className="vimdt-panel-header">
			<WbText strong>{headerName}</WbText>
			{description && (
				<WbPopover position="right" onClick={(e) => e.stopPropagation()}>
					<button type="button" className="vimdt-panel-header__info" aria-label={title || headerName}>
						<WbIcon name="bds/information/24" />
					</button>
					<div slot="content">
						<InfoPanelsTable data={data} descText={description} />
					</div>
				</WbPopover>
			)}
		</div>
	);
}

export default PanelHeader;
